<template>
<div>
    <div class="ibox animated fadeInRightBig">
		<div class="ibox-title">
			<h3>Nova Área <i class="fa fa-industry" style="float:right;font-size:21px;margin-top: -5px;"></i></h3>
		</div>
        <form id="form">
            <div class="ibox-content">
                <div class="row">
                    <div class="form-group col-md-12">
                        <label for="name"><span class="required">*</span> Nome da Área</label>
                        <input type="text" class="form-control" name="name" v-model="team.name" id="name">
                    </div>
                    <div class="form-group col-md-12">
                        <label for="photo">Foto</label>
                        <input type="file" name="photo" id="photo" class="form-control">
                    </div>
                    <div class="form-group col-md-12" style="display:flex">
                        <label for="viewAllEvents">Visualização de todos os eventos</label>
                        <input v-model="team.viewAllEvents" type="checkbox" name="viewAllEvents" id="viewAllEvents" style="width:30px;height:15px">
                    </div>
                </div>
            </div>
            <div class="ibox-footer">
                <div class="pull-right">
                    <router-link to="/teams" class="btn btn-info">
                        <i class="fa fa-arrow-left"></i> Voltar
                    </router-link>
                    <a class="btn btn-success" @click="save">
                        Salvar <i class="fa fa-save"></i>
                    </a>
                </div>
                <p><span class="required">*</span> Campos Obrigatórios</p>
                <div class="clearfix"></div>
            </div>
        </form>
    </div>
</div>
</template>

<script>
    export default {
        data() {
            return {
                team: {
                    name: '',
                    quantity_person: '',
                    photo: '',
                    viewAllEvents: '',
                },
                errors: undefined
            }
        },
        computed: {},
        methods: {
            save: function () {
                const self = this;
                const api = self.$store.state.api + 'teams';

                let form  = new FormData();
                let photo = document.getElementById('photo');

                form.append('name', self.team.name);
                form.append('quantity_person', self.team.quantity_person);
                form.append('viewAllEvents', self.team.viewAllEvents ? 1 : 0);
                form.append('photo', (photo.files[0]) ? photo.files[0] : null);

                self.$http.post(api, form)
                    .then((response) => {
                        self.teams = response.data.data;
                        self.tableData = self.teams;

                        self.$message('Sucesso', `Área cadastrada com sucesso`, 'success');

                        this.$router.push('/teams');

                        self.team = {
                            name: '',
                            quantity_person: '',
                            photo: '',
                            viewAllEvents: '',
                        };
                    })
                    .catch((error) => {
                        self.errors = error.response.data;

                        if(typeof self.errors === 'object'){
                            let html = '<ul>';

                            $.each(self.errors, function(key, value){
                                html += '<li>' + value[0] + '</li>';
                            });

                            html += '</ul>';

                            self.errors = html;
                        }

                        self.$message(null, self.errors, 'error');
                    });
            },
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/Team/Add.vue